import CloseIcon from '@/fo/icons/base/icons/cross32.svg';
import {
  UiReviewTabsBase,
  UiReviewTabsBaseProps
} from '@/fo/ui/review/tabs/base';

import { ReviewTab } from '../../types';
import { FilterPanel, FilterPanelProps } from '../FilterPanel/FilterPanel';
import { SortPanel, SortPanelProps } from '../SortPanel/SortPanel';

import { styles } from './StickyHeader.styles';

interface StickyHeaderBaseProps {
  onClose?: () => void;
}

export type StickyHeaderProps = StickyHeaderBaseProps &
  UiReviewTabsBaseProps &
  FilterPanelProps &
  SortPanelProps;

export function StickyHeader({
  tabs,
  activeTabId,
  onTabChange,
  filters,
  onFiltersChange,
  sortType,
  onSortTypeChange,
  onClose
}: StickyHeaderProps) {
  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.container()}>
        <div className={slots.tabsContainer()}>
          <UiReviewTabsBase
            tabs={tabs}
            activeTabId={activeTabId}
            onTabChange={onTabChange}
            titleClassName={slots.tabTitle()}
          />
          {onClose && (
            <button
              type="button"
              className={slots.closeButton()}
              onClick={onClose}
            >
              <CloseIcon className={slots.closeIcon()} />
            </button>
          )}
        </div>
        {activeTabId === ReviewTab.Reviews ? (
          <FilterPanel
            filters={filters}
            onFiltersChange={onFiltersChange}
          />
        ) : (
          <SortPanel
            sortType={sortType}
            onSortTypeChange={onSortTypeChange}
          />
        )}
      </div>
    </div>
  );
}
